import { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "../components/auth/ProtectedRoute";
import { ROUTES } from "./routes";
import Login from "../pages/Login";
import { Companies } from "../pages/Companies";
import { CompanyForm } from "../pages/CompanyForm";
import { Setup } from "../pages/Setup";
import { Dashboard } from "@/pages/Dashboard";
import { MainLayout } from "@/components/layout/MainLayout";
import { Outlet } from "react-router-dom";
import { CompanyDashboard } from "@/pages/CompanyDashboard";
import { Results } from "../pages/Results";
import SetPassword from "@/pages/SetPassword";
import { Footprints } from "@/pages/Footprints";
import Participation from "@/pages/Participation";
import { SharedResults } from "@/pages/SharedResults";

export const routes: RouteObject[] = [
  {
    path: ROUTES.LOGIN,
    element: (
      <ProtectedRoute requireAuth={false}>
        <Login />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.PARTICIPATION,
    element: (
      <ProtectedRoute requireAuth={false}>
        <Participation />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.SET_PASSWORD,
    element: (
      <ProtectedRoute requireAuth={false}>
        <SetPassword />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.SHARED_RESULTS,
    element: <SharedResults />,
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <MainLayout>
          <Outlet />
        </MainLayout>
      </ProtectedRoute>
    ),
    children: [
      { path: ROUTES.DASHBOARD, element: <Dashboard /> },
      { path: ROUTES.COMPANIES, element: <Companies /> },
      { path: ROUTES.COMPANY_ADD, element: <CompanyForm /> },
      { path: ROUTES.COMPANY_EDIT, element: <CompanyForm /> },
      { path: ROUTES.COMPANY_DASHBOARD, element: <CompanyDashboard /> },
      { path: ROUTES.SETUP, element: <Setup /> },
      {
        path: ROUTES.FOOTPRINTS,
        element: (
          <ProtectedRoute allowedRoles={["company", "assimagra", "get2c"]}>
            <Footprints />
          </ProtectedRoute>
        ),
      },
      {
        path: ROUTES.RESULTS,
        element: (
          <ProtectedRoute allowedRoles={["company", "assimagra", "get2c"]}>
            <Results />
          </ProtectedRoute>
        ),
      },
    ],
  },
];
